"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLTrackElementImpl extends HTMLElementImpl {
  get readyState() {
    return 0;
  }
}

module.exports = {
  implementation: HTMLTrackElementImpl
};
